import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, LockIcon, ZapIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
const BONUS_NAMES = ['Tablero de Mando Semanal Anti-Domingo', 'El Detector de Basura IA', 'Banco de Consignas Perfectas', 'Kit Anti-Corrección Infinita', 'Plantillas de Evaluación Express', 'El Organizador de Material IA'];
export function ComboSelector() {
  const [selectedCombo, setSelectedCombo] = useState<1 | 2>(2);
  const CHECKOUT_URLS: Record<1 | 2, string> = {
    1: 'https://checkout10.rosetadigital.com/cart/53096060551473:1',
    2: 'https://checkout10.rosetadigital.com/cart/53096110358833:1'
  };
  const goToCheckout = () => {
    window.open(CHECKOUT_URLS[selectedCombo], '_blank');
  };
  return <section id="pricing" className="py-10 bg-zinc-950" data-id="element-33">
      <div className="max-w-5xl mx-auto px-4" data-id="element-34">
        {/* Compact header */}
        <div className="text-center mb-5" data-id="element-35">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 text-red-500 font-bold uppercase tracking-wider text-xs mb-3 animate-pulse" data-id="element-36">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-37"></span>
            Oferta por tiempo limitado
          </div>
          <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight text-white mb-1" data-id="element-38">
            Elegí tu Combo
          </h2>
          <p className="text-base text-gray-400" data-id="element-39">
            Seleccioná el nivel que mejor se adapta a vos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" data-id="element-40">
          {/* COMBO 2 — PRO (FIRST / MÁS ELEGIDO) */}
          <div onClick={() => setSelectedCombo(2)} className={`relative cursor-pointer rounded-xl overflow-hidden transition-all duration-300 ${selectedCombo === 2 ? 'bg-zinc-900 border-2 border-yellow-500 shadow-[0_0_20px_rgba(234,179,8,0.15)]' : 'bg-zinc-900/50 border border-zinc-800 hover:border-zinc-700'}`} data-id="element-41">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-yellow-500 text-black text-[10px] font-black uppercase tracking-widest px-3 py-0.5 rounded-b-md" data-id="element-42">
              🏆 Más Elegido
            </div>

            {selectedCombo === 2 && <motion.div layoutId="active-border" className="absolute left-0 top-0 bottom-0 w-1 bg-yellow-500" data-id="element-43" />}

            <div className="p-4 md:p-5 pt-7" data-id="element-44">
              <div className="flex justify-between items-center mb-2" data-id="element-45">
                <div data-id="element-46">
                  <h3 className="text-lg font-black uppercase text-white" data-id="element-47">
                    Sistema Pro
                  </h3>
                  <p className="text-yellow-500/80 text-xs font-medium" data-id="element-48">
                    El arsenal completo
                  </p>
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedCombo === 2 ? 'border-yellow-500' : 'border-zinc-600'}`} data-id="element-49">
                  {selectedCombo === 2 && <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" data-id="element-50" />}
                </div>
              </div>

              <div className="mb-3" data-id="element-51">
                <span className="text-gray-500 line-through text-sm mr-2" data-id="element-52">
                  $99.000
                </span>
                <span className="text-3xl font-black text-white" data-id="element-53">$29.990</span>
                <span className="text-gray-400 text-sm ml-1" data-id="element-54">ARS</span>
              </div>

              <AnimatePresence data-id="element-55">
                {selectedCombo === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden border-t border-zinc-800 pt-3 mt-3" data-id="element-56">
                    <ul className="space-y-1.5 text-xs" data-id="element-57">
                      <li className="flex items-center gap-2" data-id="element-58">
                        <CheckCircle2Icon className="w-4 h-4 text-yellow-500 flex-shrink-0" data-id="element-59" />
                        <span className="text-white font-medium" data-id="element-60">
                          📘 Sistema de Productividad Docente (6 Tomos)
                        </span>
                      </li>
                      <li className="flex items-center gap-2 bg-yellow-500/10 px-2 py-1 rounded border border-yellow-500/20 -mx-1" data-id="element-61">
                        <CheckCircle2Icon className="w-4 h-4 text-yellow-500 flex-shrink-0" data-id="element-62" />
                        <span className="text-yellow-500 font-bold" data-id="element-63">
                          📗 El Arsenal Docente™ — +300 Plantillas listas para
                          crear contenido
                        </span>
                      </li>
                      {BONUS_NAMES.map((name, idx) => <li key={idx} className="flex items-center gap-2" data-id="element-64">
                          <CheckCircle2Icon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-65" />
                          <span className="text-gray-300" data-id="element-66">
                            {name}{' '}
                            <span className="text-green-500 font-bold" data-id="element-67">
                              (Gratis)
                            </span>
                          </span>
                        </li>)}
                      <li className="flex items-center gap-2 pt-1 text-gray-400" data-id="element-68">
                        <MailIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-69" /> PDF
                        por email ·{' '}
                        <ZapIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-70" /> Acceso
                        inmediato
                      </li>
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>

          {/* COMBO 1 — BASE (SECOND) */}
          <div onClick={() => setSelectedCombo(1)} className={`relative cursor-pointer rounded-xl overflow-hidden transition-all duration-300 ${selectedCombo === 1 ? 'bg-zinc-900 border-2 border-yellow-500 shadow-[0_0_20px_rgba(234,179,8,0.15)]' : 'bg-zinc-900/50 border border-zinc-800 hover:border-zinc-700'}`} data-id="element-71">
            {selectedCombo === 1 && <motion.div layoutId="active-border" className="absolute left-0 top-0 bottom-0 w-1 bg-yellow-500" data-id="element-72" />}

            <div className="p-4 md:p-5" data-id="element-73">
              <div className="flex justify-between items-center mb-2" data-id="element-74">
                <div data-id="element-75">
                  <h3 className="text-lg font-black uppercase text-white" data-id="element-76">
                    Sistema Base
                  </h3>
                  <p className="text-gray-400 text-xs" data-id="element-77">
                    Lo esencial para empezar
                  </p>
                </div>
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedCombo === 1 ? 'border-yellow-500' : 'border-zinc-600'}`} data-id="element-78">
                  {selectedCombo === 1 && <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" data-id="element-79" />}
                </div>
              </div>

              <div className="mb-3" data-id="element-80">
                <span className="text-gray-500 line-through text-sm mr-2" data-id="element-81">
                  $64.000
                </span>
                <span className="text-3xl font-black text-white" data-id="element-82">$19.990</span>
                <span className="text-gray-400 text-sm ml-1" data-id="element-83">ARS</span>
              </div>

              <AnimatePresence data-id="element-84">
                {selectedCombo === 1 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden border-t border-zinc-800 pt-3 mt-3" data-id="element-85">
                    <ul className="space-y-1.5 text-xs" data-id="element-86">
                      <li className="flex items-center gap-2" data-id="element-87">
                        <CheckCircle2Icon className="w-4 h-4 text-yellow-500 flex-shrink-0" data-id="element-88" />
                        <span className="text-white font-medium" data-id="element-89">
                          📘 Sistema de Productividad Docente (6 Tomos)
                        </span>
                      </li>
                      {BONUS_NAMES.map((name, idx) => <li key={idx} className="flex items-center gap-2" data-id="element-90">
                          <CheckCircle2Icon className="w-3.5 h-3.5 text-green-500 flex-shrink-0" data-id="element-91" />
                          <span className="text-gray-300" data-id="element-92">
                            {name}{' '}
                            <span className="text-green-500 font-bold" data-id="element-93">
                              (Gratis)
                            </span>
                          </span>
                        </li>)}
                      <li className="flex items-center gap-2 pt-1 text-gray-400" data-id="element-94">
                        <MailIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-95" /> PDF
                        por email ·{' '}
                        <ZapIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-96" /> Acceso
                        inmediato
                      </li>
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>

        {/* Compact CTA */}
        <div className="max-w-xl mx-auto" data-id="element-97">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={goToCheckout} className="w-full bg-yellow-500 text-black font-black uppercase py-4 rounded-xl text-lg shadow-[0_0_30px_rgba(234,179,8,0.3)] hover:shadow-[0_0_40px_rgba(234,179,8,0.5)] transition-all flex items-center justify-center gap-2" data-id="element-98">
            COMPRAR AHORA <ArrowRightIcon className="w-5 h-5" data-id="element-99" />
          </motion.button>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mt-3 text-xs text-gray-400" data-id="element-100">
            <div className="flex items-center gap-1" data-id="element-101">
              <LockIcon className="w-3.5 h-3.5 text-gray-500" data-id="element-102" /> Pago 100%
              Seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-103">
              <ZapIcon className="w-3.5 h-3.5 text-yellow-500" data-id="element-104" /> Acceso
              Inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-105">
              <MailIcon className="w-3.5 h-3.5 text-gray-500" data-id="element-106" /> PDF por Email
            </div>
          </div>
        </div>
      </div>
    </section>;
}